import React, { useEffect, useState } from 'react';

function PcaConsolidadoModal({ show, onClose, item, onSave }) {
  const [form, setForm] = useState({ id: null, listaDfds: [], listaItens: [] });

  useEffect(() => {
    if (item) {
      setForm({
        id: item.id,
        listaDfds: item.listaDfds || [],
        listaItens: item.listaItens || [],
      });
    } else {
      setForm({ id: null, listaDfds: [], listaItens: [] });
    }
  }, [item]);

  if (!show) return null;

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    // allow user to edit lists as comma separated strings or keep arrays
    const payload = {
      id: form.id,
      listaDfds: Array.isArray(form.listaDfds) ? form.listaDfds : String(form.listaDfds).split(',').map(s => s.trim()).filter(Boolean),
      listaItens: Array.isArray(form.listaItens) ? form.listaItens : String(form.listaItens).split(',').map(s => s.trim()).filter(Boolean),
    };
    onSave(payload);
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-header text-white py-1" style={{ background: 'linear-gradient(90deg, #0b3383, #0e48ad)' }}>
            <h6 className="modal-title m-0">{form.id ? 'Editar Consolidação' : 'Nova Consolidação'}</h6>
            <button
              className="btn btn-link text-white p-0 mb-0"
              onClick={onClose}
              title="Fechar"
              style={{ fontSize: '0.9rem', textDecoration: 'none' }}
            >
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
          <div className="modal-body">
            <div className="mb-2">
              <label className="form-label">ID</label>
              <input name="id" className="form-control form-control-sm" value={form.id || ''} readOnly />
            </div>
            <div className="mb-2">
              <label className="form-label">LISTA_DFDS</label>
              <textarea name="listaDfds" className="form-control form-control-sm" rows={3} value={Array.isArray(form.listaDfds) ? form.listaDfds.join(', ') : form.listaDfds} onChange={handleChange} />
            </div>
            <div className="mb-2">
              <label className="form-label">LISTA_ITENS</label>
              <textarea name="listaItens" className="form-control form-control-sm" rows={3} value={Array.isArray(form.listaItens) ? form.listaItens.join(', ') : form.listaItens} onChange={handleChange} />
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Cancelar</button>
            <button className="btn btn-primary" onClick={handleSubmit}>{form.id ? 'Salvar' : 'Criar'}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PcaConsolidadoModal;
